/**
 * Google Maps configuration constants
 */

// Default map zoom level
export const DEFAULT_MAP_ZOOM = 12;
export const MAP_MIN_HEIGHT = '500px';
export const MAP_BORDER_RADIUS = '8px';

// Default/fallback map center coordinates (New York City)
export const DEFAULT_MAP_CENTER = {
	lat: 40.7128,
	lng: -74.006
};
